import { render, staticRenderFns } from "./PrescriptionQueue.vue?vue&type=template&id=3ea3a6d2&scoped=true&lang=pug"
import script from "./PrescriptionQueue.vue?vue&type=script&lang=js"
export * from "./PrescriptionQueue.vue?vue&type=script&lang=js"
import style0 from "./PrescriptionQueue.vue?vue&type=style&index=0&id=3ea3a6d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea3a6d2",
  null
  
)

export default component.exports